// Contact.jsx – Form with EmailJS Integration
import { useRef } from 'react';
import emailjs from 'emailjs-com';

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      'service_fes810k',
      'template_q3vsbox',
      formRef.current,
      'R7eWMQcRk7QSfffhV'
    ).then(() => {
      alert("Message sent successfully!");
      formRef.current.reset();
    }).catch(err => {
      alert("Submission failed. Try again.");
      console.error("EmailJS Error:", err);
    });
  };

  return (
    <div style={{ padding: '40px 20px', maxWidth: '600px', margin: 'auto' }}>
      <h2 style={{ fontSize: '2rem', color: '#6A0DAD', marginBottom: '1rem' }}>Contact Us</h2>
      <form ref={formRef} onSubmit={handleSubmit}>
        <label>Your Name</label>
        <input type="text" name="name" required />

        <label>Your Email</label>
        <input type="email" name="email" required />

        <label>Your Message</label>
        <textarea name="message" rows="5" required />

        <button type="submit">Send</button>
      </form>
    </div>
  );
};

export default Contact;
